
/**
 * Cookie Helper
 */
class CookieHelper {


    /**
     * Gets value from requested key in cookies.
     * 
     * @returns string
     */
    static get(key) {
    
       let pair = document.cookie.match(new RegExp(key + '=([^;]+)'));
	    return !!pair ? pair[1] : '';
    }
}

export default CookieHelper;



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/helpers/cookie-helper.js
// module id = 75
// module chunks = 13